import { produce } from "immer";
import type { AnnualisedRow } from "./types";

export function getAnnualisedHeaders(headers: AnnualisedRow) {
	const [, ..._headers] = headers;
	return _headers;
}
export function getAnnualisedData(data: AnnualisedRow[], labels?: string[]) {
	return data.reduce((acc, row) => {
		const [label, ...values] = row;
		if (!labels || labels.includes(label)) {
			acc.push(values);
		}
		return acc;
	}, [] as string[][]);
}
export function getLabelReplacedData(
	data: string[][],
	replaceMap: Record<string, string>,
) {
	return produce(data, (draft) => {
		for (let i = 0; i < draft.length; i++) {
			const row = draft[i];
			for (let j = 0; j < row.length; j++) {
				const cell = row[j];
				if (cell in replaceMap) {
					row[j] = replaceMap[cell];
				}
			}
		}
	});
}
